import React from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import WebsitesCardBasicInfo from './website-card-basic-info.component';


export const WebsitesCardComponent = ({ cardTypes, tenantWebCards, cardDetailInfo, handleCloseProductModal, handleOpenProductModal, setPageSize, isModalOpen, isModalProductOpen, handleOpenModal, handleCloseModal, setPageData,
  additionButtons, onSelect, categoryColumnDefs, productsPaginationData, productColumnDefs, categories, products, categoriesPaginationData, handleFormSubmit, back, cardTemplate, cardValues, handleFormChange, deleteTenantwebCardItem, changeCardFile }: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'Website Card Information',
      component: <WebsitesCardBasicInfo
        cardDetailInfo={cardDetailInfo}
        tenantWebCards={tenantWebCards}
        cardTypes={cardTypes}
        deleteTenantwebCardItem={deleteTenantwebCardItem}
        changeCardFile={changeCardFile}
        handleFormChange={handleFormChange}
        cardValues={cardValues}
        cardTemplate={cardTemplate}
        categoryColumnDefs={categoryColumnDefs}
        setPageData={setPageData}
        categoriesPaginationData={categoriesPaginationData}
        products={products}
        categories={categories}
        productColumnDefs={productColumnDefs}
        productsPaginationData={productsPaginationData}
        setPageSize={setPageSize}
        onSelect={onSelect}
        additionButtons={additionButtons}
        isModalOpen={isModalOpen}
        isModalProductOpen={isModalProductOpen}
        handleOpenModal={handleOpenModal}
        handleCloseModal={handleCloseModal}
        handleOpenProductModal={handleOpenProductModal}
        handleCloseProductModal={handleCloseProductModal}
      />,
      isVisible: true,
    },


  ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end h-20'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default WebsitesCardComponent;
